module.exports = __webpack_public_path__ + "h5/img/zj.a6f78a7a.png";